<div class="relatorio-container">
    <!-- Cabeçalho -->
    <div class="relatorio-header"
        style="display: flex; align-items: center; gap: 15px; flex-wrap: wrap; justify-content: space-between;">
        <!-- Dropdown de Grupo -->
        <div class="header-item" style="flex: 1; min-width: 250px;">
            <label for="grupo">Grupo</label>
            <p-dropdown id="grupo" [options]="grupos" [(ngModel)]="grupoSelecionado" (onChange)="onGrupoChange()"
                [style]="{ width: '100%' }"></p-dropdown>
        </div>

        <!-- Dropdown de Relatório -->
        <div class="header-item" style="flex: 2; min-width: 350px;">
            <label for="relatorio">Relatório</label>
            <p-dropdown id="relatorio" [options]="relatorios" [(ngModel)]="relatorioSelecionado" optionLabel="label"
                optionValue="value" (onChange)="onRelatorioChange()" [style]="{ width: '100%' }">
            </p-dropdown>
        </div>
        <!-- Botões de ações -->
        <div class="actions" style="display: flex; gap: 10px; flex-wrap: wrap; justify-content: flex-end; align-items: center;">
            <button pButton label="Pesquisar" icon="pi pi-search" (click)="pesquisar()" style="min-width: 120px; margin-top: 0.9rem;"></button>
            <p-tieredMenu #menu [model]="itemsFunctions" [popup]="true" appendTo="body"></p-tieredMenu>
            <button pButton label="Funções" icon="pi pi-cog" class="p-button-secondary" (click)="menu.toggle($event)" style="min-width: 120px; margin-top: 0.9rem;"></button>                
            <!-- <button pButton label="Imprimir" icon="pi pi-print" class="p-button-info" (click)="imprimirRelatorio()" style="min-width: 120px; margin-top: 0.9rem;"></button> -->
            <button pButton label="Sair" icon="pi pi-power-off" class="p-button-danger" (click)="sair()" style="min-width: 120px; margin-top: 0.9rem;"></button>
            <div>
                <!-- Tooltip Customizado -->
                <div *ngIf="mostrarTooltip" 
                    style="position: absolute; bottom: 100%; right: 0; margin-bottom: 5px; background-color: #333; color: #fff; padding: 8px 12px; border-radius: 4px; font-size: 14px; box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);">
                    Visualizar campos de configurações extras, clique aqui!
                </div>
                <!-- Botão -->
                <button pButton 
                        type="button" 
                        label="{{ exibirConteudo ? 'Ocultar Configurações' : 'Mostrar Configurações' }}" 
                        icon="{{ exibirConteudo ? 'pi pi-eye-slash' : 'pi pi-eye' }}" 
                        class="p-button-text p-button-sm" 
                        (click)="exibirConteudo = !exibirConteudo"
                        style="min-width: 120px; margin-top: 0.9rem;">
                </button>
            </div>
        </div>
        
    </div>

    <!-- Botão para ocultar/mostrar todo o bloco 
    <div class="relatorio-header" style="display: flex; align-items: center; gap: 15px; flex-wrap: wrap; justify-content: space-between;">
        <div style="width: 100%; display: flex; justify-content: flex-end; margin-bottom: 10px; position: relative;">-->
            <!-- Tooltip Customizado 
            <div *ngIf="mostrarTooltip" 
                style="position: absolute; bottom: 100%; right: 0; margin-bottom: 5px; background-color: #333; color: #fff; padding: 8px 12px; border-radius: 4px; font-size: 14px; box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);">
                Visualizar campos de configurações extras, clique aqui!
            </div>-->
            <!-- Botão 
            <button pButton 
                    type="button" 
                    label="{{ exibirConteudo ? 'Ocultar Configurações' : 'Mostrar Configurações' }}" 
                    icon="{{ exibirConteudo ? 'pi pi-eye-slash' : 'pi pi-eye' }}" 
                    class="p-button-text p-button-sm" 
                    (click)="exibirConteudo = !exibirConteudo">
            </button>
        </div>
    </div>-->

        <div *ngIf="exibirConteudo" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: stretch; justify-content: space-between;">
            <!-- Contêiner Empresa(s) -->
            <!--<div
                style="flex: 1; min-width: 150px; max-width: 20%; border: 1px solid #ccc; border-radius: 5px; padding: 10px; background-color: #fff; position: relative;">
                <div
                    style="position: absolute; top: -10px; left: 10px; background-color: #fff; padding: 0 5px; font-size: 14px; color: #555;">
                    Empresa(s)
                </div>
                <div style="margin-top: 10px;">
                    <ul>
                        <ng-container *ngFor="let parametro of parametros">
                            <li *ngIf="parametro.campo === 'Empresa'">
                                {{ parametro.valor }}
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div> -->
            <!-- Configurações adicionais -->
            <div style="flex: 1; min-width: 250px; max-width: 27%; border: 1px solid #ccc; border-radius: 5px; padding: 10px; background-color: #fff; 
            position: relative">
            <!-- Título na borda -->
            <div
                style="position: absolute; top: -10px; left: 10px; background-color: #fff; padding: 0 5px; font-size: 14px; color: #555;">
                Configurações de Impressão
            </div>

            <!-- Linha 1 -->
            <div
                style="display: flex; align-items: center; justify-content: space-between; gap: 15px; flex-wrap: wrap; margin-bottom: 10px;">
                <div style="display: flex; align-items: center; gap: 10px; flex: 1;">
                    <p-checkbox name="imprimirQuebraPag" [(ngModel)]="imprimirQuebraPag" [binary]="true"></p-checkbox>
                    <label for="imprimirQuebraPag">Imprimir Quebra Pág.</label>
                </div>
                <div style="display: flex; align-items: center; gap: 10px; flex: 1;">
                    <label for="imprimirLinhas">Imprimir Linhas:</label>
                    <p-dropdown id="imprimirLinhas" [options]="opcoesLinhas" [(ngModel)]="imprimirLinhasSelecionado"
                        style="width: 120px;"></p-dropdown>
                </div>
            </div>

            <!-- Linha 2 -->
            <div
                style="display: flex; align-items: center; justify-content: space-between; gap: 15px; flex-wrap: wrap; margin-bottom: 10px;">
                <div style="display: flex; align-items: center; gap: 10px; flex: 1;">
                    <p-checkbox name="imprimirDetalhes" [(ngModel)]="imprimirDetalhes" [binary]="true"></p-checkbox>
                    <label for="imprimirDetalhes">Imprimir Detalhes</label>
                </div>
                <div style="display: flex; align-items: center; gap: 10px; flex: 1;">
                    <label for="orientacao">Orientação:</label>
                    <p-dropdown id="orientacao" [options]="orientacoes" [(ngModel)]="orientacaoSelecionada"
                        style="width: 120px;"></p-dropdown>
                </div>
            </div>

            <!-- Linha 3 -->
            <div style="display: flex; align-items: center; gap: 15px; justify-content: flex-start; flex-wrap: wrap;">
                <label for="espacoLinhas">Espaço entre Linhas:</label>
                <input id="espacoLinhas" type="number" pInputText [(ngModel)]="espacoEntreLinhas"
                    style="width: 60px;" />
            </div>
        </div>

    <!--     <div style="flex: 1; border: 1px solid #ccc; border-radius: 5px; padding: 10px; background-color: #fff; position: relative;">
            <div style="position: absolute; top: -10px; left: 10px; background-color: #fff; padding: 0 5px; font-size: 14px; color: #555;">
                Campos Disponíveis Teste
            </div>
            <div style="margin-top: 10px; display: grid; grid-auto-flow: column; grid-template-rows: repeat(4, auto); gap: 10px;">
                <ng-container *ngFor="let field of checkboxFields">
                    <div>
                        <p-checkbox [(ngModel)]="field.selected" [label]="field.label" [binary]="true"></p-checkbox>
                    </div>
                </ng-container>
            </div>
        </div>  -->  
        
        <div style="flex: 1; border: 1px solid #ccc; border-radius: 5px; padding: 10px; background-color: #fff; position: relative;">
            <div style="position: absolute; top: -10px; left: 10px; background-color: #fff; padding: 0 5px; font-size: 14px; color: #555;">
                Campos Disponíveis
            </div>
            <div class="container">
                <label for="multiSelect" class="full-width-label">Cabeçalho:</label>
                <p-multiSelect
                    id="multiSelect"
                    [options]="checkboxFields"
                    [(ngModel)]="selectedFields"
                    optionLabel="label"
                    placeholder="Selecione os campos"
                    styleClass="custom-multiselect" [style]="{ width: '100%' }">
                </p-multiSelect>
            </div>
            <div class="container" *ngIf="subCheckboxFields.length > 0">
                <label for="subMultiSelect" class="full-width-label">Detalhes:</label>
                <p-multiSelect
                    id="subMultiSelect"
                    [options]="subCheckboxFields"
                    [(ngModel)]="selectedSubFields"
                    optionLabel="label"
                    placeholder="Selecione os detalhes"
                    styleClass="custom-multiselect"
                    [style]="{ width: '100%' }"
                    appendTo="body">
                </p-multiSelect>
            </div>
        </div>
        
        <!-- Tabela de parâmetros -->
        <div
            style="flex: 1; min-width: 250px; max-width: 30%; border: 1px solid #ccc; border-radius: 5px; padding: 10px; background-color: #fff; position: relative;">
            <div
                style="position: absolute; top: -10px; left: 10px; background-color: #fff; padding: 0 5px; font-size: 14px; color: #555;">
                Parâmetros da Pesquisa
            </div>
            <p-table [value]="parametrosFiltrados" [resizableColumns]="true" [reorderableColumns]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="campo">Campo <p-sortIcon field="campo"></p-sortIcon></th>
                        <th pSortableColumn="valor">Valor <p-sortIcon field="valor"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-param>
                    <tr>
                        <td>{{ param.campo }}</td>
                        <td>
                            {{ isDate(param.valor, param.campo) ? formatDateTime(param.valor) : param.valor }}
                        </td>
                        
                    </tr>
                </ng-template>
            </p-table>

        </div>

    </div>


    <div class="table-container" style="width: 100%; margin: 10px auto; overflow-x: auto;">
        <p-tabView>
            <p-tabPanel header="Tabela">
                <p-table #dt id="dt" [columns]="headers" [value]="rows" [resizableColumns]="true" [rows]="11" [paginator]="true"[scrollable]="true" [autoLayout]="true"
                    [style]="{ 'width': '100%' }" styleClass="p-datatable-striped p-datatable-sm" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let header of headers">{{ header }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td *ngFor="let header of headers">{{ row[header] }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
            <p-tabPanel header="Gráfico" *ngIf="exibirGrafico">
                <div class="chart-legend-class"style="display: flex; justify-content: center; gap: 20px; margin-bottom: 10px; align-items: center;">
                    <div style="display: flex; justify-content: center; gap: 20px; margin-bottom: 10px; align-items: center;">
                        <div style="text-align: center;">
                            <label for="posicaoLegenda">Posição da Legenda: </label>
                            <p-dropdown 
                                id="posicaoLegenda" 
                                [options]="opcoesLegenda" 
                                [(ngModel)]="posicaoLegenda" 
                                (onChange)="atualizarGrafico()">
                            </p-dropdown>
                        </div> 
                    
                        <div style="text-align: center;">
                            <label for="tipoGrafico">Tipo de Gráfico: </label>
                            <p-dropdown 
                            id="tipoGrafico" 
                            [options]="opcoesTipoGrafico" 
                            [(ngModel)]="graficoTipo" 
                            (onChange)="atualizarGrafico()">
                        </p-dropdown>                        
                        </div>
                    
                        <div *ngIf="graficoTipo === 'bar'" style="text-align: center;">
                            <label for="tipoBarra">Configuração de Barras: </label>
                            <p-dropdown 
                                id="tipoBarra" 
                                [options]="opcoesTipoBarra" 
                                [(ngModel)]="configuracaoBarra" 
                                (onChange)="atualizarGrafico()">
                            </p-dropdown>
                        </div>
                    </div>
                    
                </div>  
                <h2 style="text-align: center;">{{ tituloRelatorioGrafico }}</h2>                      
                <div id="printContainer" style="display: none;">
                    <h2 id="printTitle"></h2>
                    <img id="printGraph" style="width: 100%; height: auto;" />
                </div>
                <canvas id="graficoCanvas" style="width: 100%; max-height: 400px;"></canvas>
            </p-tabPanel>                               
        </p-tabView> 
    </div>
 